export default {
      id: "huge-file-attach-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-file-attach",
      toString: function () {
        return this.url;
      }
    }